import React from "react";
import { Column } from "../types";
import { TableHead } from "./TableHead";
import { TableBody } from "./TableBody";
import { TableFooter } from "./TableFooter";
import { TableContainer } from "./TableContainer";

interface Props<Data extends Record<string, any>, Context extends any = any> {
  context: Context;
  tableData: Data[];
  loading: boolean;
  columns: Column<Data, Context>[];
}

export const Table = <Data extends Record<string, any>, Context extends any = any>({
  columns,
  loading,
  context,
  tableData,
}: Props<Data, Context>) => (
  <TableContainer>
    <TableHead<Data, Context> columns={columns} context={context} />
    <TableBody<Data, Context> columns={columns} loading={loading} tableData={tableData} context={context} />
    <TableFooter<Data, Context> columns={columns} loading={loading} tableData={tableData} context={context} />
  </TableContainer>
);
